import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, Form, reduxForm } from 'redux-form';
import { Spinner } from 'UI';
import { Flex, Button, Icon, TooltipMenu, Skeleton } from '@haldor/ui';
import swal from 'sweetalert2';

var GuardianDetailsForm = /*#__PURE__*/function (_Component) {
  _inherits(GuardianDetailsForm, _Component);

  var _super = _createSuper(GuardianDetailsForm);

  function GuardianDetailsForm(props) {
    var _this;

    _classCallCheck(this, GuardianDetailsForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      if (values.mail != null) {
        values.mail = values.mail.trim();
      }

      var currentGuardian = _this.props.currentGuardian;

      if (currentGuardian.id != "" && currentGuardian.mail != null && currentGuardian.mail != '') {
        if (currentGuardian.mail.toLowerCase() != values.mail.toLowerCase()) {
          swal.fire({
            title: _this.props.translate('are-you-sure'),
            text: _this.props.translate('changing-email-will-also-affect-userlogin'),
            showCancelButton: true,
            focusConfirm: false,
            cancelButtonText: _this.props.translate('No'),
            confirmButtonText: _this.props.translate('Yes')
          }).then(function (result) {
            if (result.value == null) {
              values.mail = _this.props.currentGuardian.mail;
            }

            _this.setState({
              loading: true
            });

            _this.props.onModalSave(values);
          });
          return true;
        }
      }

      _this.setState({
        loading: true
      });

      _this.props.onModalSave(values);
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function () {
      var currentGuardian = _this.state.currentGuardian;
      currentGuardian.active = _this.state.active;

      _this.setState({
        currentGuardian: currentGuardian
      });

      _this.props.cancelModal();
    });

    _defineProperty(_assertThisInitialized(_this), "changeGuardianPermissionLevel", function (status) {
      var currentGuardian = _this.state.currentGuardian;
      currentGuardian.active = status;

      _this.setState({
        currentGuardian: currentGuardian
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMailChanged", function (email) {
      _this.props.onMailChanged(email);
    });

    _defineProperty(_assertThisInitialized(_this), "mailRequired", function (value) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (re.test(String(value).toLowerCase())) {
        if (typeof value !== 'undefined' && value !== '') {
          // Field passes validation, return a undefined error for this field
          // Rule: Not undefined and not an empty string
          return undefined;
        }
      }

      return _this.props.translate('field-needs-input');
    });

    var noStudent = false;

    if (_this.props.noStudent != null) {
      noStudent = true;
    }

    if (_this.props.currentGuardian.id != "") {
      _this.state = {
        active: _this.props.currentGuardian.active,
        currentGuardian: _this.props.currentGuardian,
        loading: false,
        noStudent: noStudent,
        editForm: true
      };
    } else {
      _this.state = {
        active: _this.props.currentGuardian.active,
        currentGuardian: _this.props.currentGuardian,
        loading: false,
        noStudent: noStudent,
        editForm: false
      };
    }

    return _this;
  }

  _createClass(GuardianDetailsForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          valid = _this$props.valid,
          goal = _this$props.goal,
          initialValues = _this$props.initialValues;
      return /*#__PURE__*/React.createElement("div", {
        className: "userdetails edit-form"
      }, !this.state.loading ? /*#__PURE__*/React.createElement(Form, {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, this.state.editForm == false ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('e-mail')), /*#__PURE__*/React.createElement(Field, {
        name: "mail",
        type: "text",
        component: "input",
        onBlur: function onBlur(event) {
          return _this2.onMailChanged(event.target.value);
        }
      }), this.props.errorMessage != null ? /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red',
          marginTop: '1rem',
          fontWeight: 'bold'
        }
      }, this.props.errorMessage) : null) : null, !this.props.searchingGuardian ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "left",
          width: "50%",
          paddingRight: "1.75em"
        }
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('firstname')), /*#__PURE__*/React.createElement(Field, {
        name: "firstName",
        type: "text",
        component: "input"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "left",
          width: "50%",
          paddingRight: "0px"
        }
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('surname')), /*#__PURE__*/React.createElement(Field, {
        name: "lastName",
        type: "text",
        component: "input"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('phone')), /*#__PURE__*/React.createElement(Field, {
        name: "phone",
        type: "text",
        component: "input"
      }))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "left",
          width: "50%",
          paddingRight: "1.75em"
        }
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('firstname')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Skeleton, {
        style: {
          height: '4em'
        }
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "left",
          width: "50%",
          paddingRight: "0px"
        }
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('surname')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Skeleton, {
        style: {
          height: '4em'
        }
      })))), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('phone')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Skeleton, {
        style: {
          height: '4em'
        }
      })))), this.state.editForm == true ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('e-mail')), /*#__PURE__*/React.createElement(Field, {
        name: "mail",
        type: "text",
        component: "input",
        disabled: this.state.currentGuardian.synced
      })) : null, !this.props.searchingGuardian ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('street-address')), /*#__PURE__*/React.createElement(Field, {
        name: "street",
        type: "text",
        component: "input"
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "left",
          width: "35%",
          paddingRight: "1.75em"
        }
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('zip-code')), /*#__PURE__*/React.createElement(Field, {
        name: "postal",
        type: "text",
        component: "input"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "left",
          width: "65%"
        }
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('address')), /*#__PURE__*/React.createElement(Field, {
        name: "city",
        type: "text",
        component: "input"
      })), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('street-address')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Skeleton, {
        style: {
          height: '4em'
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "left",
          width: "35%",
          paddingRight: "1.75em"
        }
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('zip-code')), /*#__PURE__*/React.createElement("div", {
        style: {
          height: '3em'
        }
      }, /*#__PURE__*/React.createElement(Skeleton, {
        style: {
          height: '4em'
        }
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          "float": "left",
          width: "65%"
        }
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('address')), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Skeleton, {
        style: {
          height: '4em'
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('select-language')), /*#__PURE__*/React.createElement(Field, {
        component: "select",
        name: "lcid"
      }, /*#__PURE__*/React.createElement("option", {
        value: "sv-SE"
      }, this.props.translate('swedish')), /*#__PURE__*/React.createElement("option", {
        value: "en-US"
      }, this.props.translate('english')), /*#__PURE__*/React.createElement("option", {
        value: "nb-NO"
      }, this.props.translate('norwegian')), /*#__PURE__*/React.createElement("option", {
        value: "fi-FI"
      }, this.props.translate('finish')), /*#__PURE__*/React.createElement("option", {
        value: "da-DK"
      }, this.props.translate('danish')), /*#__PURE__*/React.createElement("option", {
        value: "uk"
      }, this.props.translate('ukrainian'))))), this.state.editForm == true && !this.state.noStudent ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('permissions-as-guardian')), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("label", {
        style: {
          marginTop: "0px",
          width: "80%"
        }
      }, this.state.currentGuardian.firstName + " " + (this.state.currentGuardian.lastName != null ? this.state.currentGuardian.lastName : null)), /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: this.state.currentGuardian.active ? /*#__PURE__*/React.createElement("div", null, this.props.translate('active'), /*#__PURE__*/React.createElement(Icon, {
          name: "Chevron"
        })) : /*#__PURE__*/React.createElement("div", null, this.props.translate('inactive'), /*#__PURE__*/React.createElement(Icon, {
          name: "Chevron"
        })),
        id: "studentPermissionsTooltip"
      }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.changeGuardianPermissionLevel(!initialValues.active);
        }
      }, this.state.currentGuardian.active ? this.props.translate('inactive') : this.props.translate('active'))))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-row submit",
        style: {
          marginTop: '1.25rem',
          marginBottom: '1.25rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: submitting || !valid
      }, this.props.translate('save')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onCancel
      }, this.props.translate('Cancel'))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })));
    }
  }]);

  return GuardianDetailsForm;
}(Component);

function mapStateToProps(state, ownProps) {
  return {
    initialValues: ownProps.currentGuardian,
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(reduxForm({
  form: 'GuardianDetailForm',
  destroyOnUnmount: true
})(GuardianDetailsForm));